var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.chartOptions.colors.length > 0)?_c('apexchart',{attrs:{"width":"100%","height":"200px","options":_vm.chartOptions,"series":_vm.areaChartSeries}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }